import React, { useState, useEffect, ChangeEventHandler, HtmlHTMLAttributes } from "react";
import { ProjectTypeType } from "types/project-type";
import "./project-type-item.scss";

function ProjectTypeItem({ ProductType, setShowCildren, showCildren, AddItemToTotal, contactsCount }: { ProductType: ProjectTypeType; setShowCildren: any; showCildren: any; AddItemToTotal: any; contactsCount: number }) {
  const [projectType, setProjectType] = useState<ProjectTypeType>(ProductType);

  const ManageInput = (action: string) => {
    if (action === "add") {
      ManageInputNumber(projectType.Amount + 1);
    } else {
      var newValue = projectType.Amount - 1;
      if (projectType.Quantifiable == true && projectType.IsDefault == true) {
        if (newValue < 1) {
          return;
        }
      }
      if (newValue < 0) {
        return;
      }
      ManageInputNumber(projectType.Amount - 1);
    }
  };

  const ManageCheckBox = (action: React.ChangeEvent<HTMLInputElement>) => {
    var newState = projectType;
    if (action.target.checked) {
      ManageInputNumber(1);
    } else {
      ManageInputNumber(0);
    }
  };

  const ManageInputNumber = (newAmount: number) => {
    var newState = projectType;
    newState.Amount = newAmount;
    setProjectType(newState);
    AddItemToTotal(projectType);
  };

  useEffect(() => {
    if (projectType.IsDefault) {
      ManageInputNumber(1);
    }
  }, [projectType]);

  return (
    <div className="L_SelectOption ProjectTypeItem" onClick={() => setShowCildren(!showCildren)}>
      <div className="item">
        <div>
          <label className="boxSelction">
            {ProductType.Description}
            {!projectType.IsDefault ? <input type="checkbox" onChange={(event) => ManageCheckBox(event)} /> : <input type="checkbox" checked={true} />}
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="Price">R {(ProductType.Price).toFixed(2)}</div>
        <div className="counter" style={ProductType.Quantifiable === true ? { display: "block" } : { display: "none" }}>
          <label></label>
          <input className="input-number-decrement" onClick={() => ManageInput("deduct")} value="-" />
          <input id="standard" className="input-number" type="text" value={projectType.Amount} />
          <input className="input-number-increment" onClick={() => ManageInput("add")} value="+" />
        </div>
      </div>
    </div>
  );
}

export default ProjectTypeItem;
